import React from 'react'
import HospitalClaimDetails from '../HospitalClaimDetails/HospitalClaimDetails'
import FuneralClaimDetails from '../FuneralClaimDetails/FuneralClaimDetails'
import DisabilityClaimDetails from '../DisabilityDetails/DisabilityClaimDetails'

export default function AdditionalDetails(props) {


  if(props.hasHospiCashIllnessBenefit || props.hasHospiCashAccidentBenefit){
    return <HospitalClaimDetails {...props} />
  }
  if(props.hasFuneralNaturalDeath || props.hasFuneralAccidentalDeath || props.hasAccidentalDeathBenefit || props.hasNaturalDeathBenefit || props.isMalawiFuneralBenefits){
    return <FuneralClaimDetails {...props} />
  }
  if(props.hasPartialPermanentDisabilityBenefit || props.hasTotalPermanentDisabilityBenefit){
    return <DisabilityClaimDetails {...props} />
  }

  // No matching claim-detail form for the selected benefit — render nothing
  // rather than returning undefined (which crashes React).
  return null
}
